module.exports = __webpack_public_path__ + "media/images/nano-preview-58aad359d769ee9c701533f17f28fa9e.webm";